var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"name":_vm.name,"label":_vm.label,"help-text":_vm.helpText,"error":_vm.error}},[_c('input',{staticClass:"form-control",attrs:{"type":"email","id":_vm.name,"placeholder":_vm.label,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }